module.exports = __webpack_public_path__ + "static/tally.e1d0bbbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tally.png
// module id = ./src/assets/images/tally.png
// module chunks = 35783957827783